export function getUnifiedPageDetailLookupOptions(searchParams: URLSearchParams) {
  const libraryUrlId = searchParams.get('libraryUrlId') || undefined
  const scanPageId = searchParams.get('scanPageId') || undefined
  const schemaGenerationId = searchParams.get('schemaGenerationId') || undefined

  return {
    ...(libraryUrlId ? { libraryUrlId } : {}),
    ...(scanPageId ? { scanPageId } : {}),
    ...(schemaGenerationId ? { schemaGenerationId } : {}),
  }
}

/*
  "Write it now." The dashboard's free page step opens the page detail with
  this on the address, and the page detail writes the free first page once,
  without another press, then takes it off the address so a reload or Back
  cannot ask again. It lives on the address and nowhere else: the page is
  never looked up by it, and nothing stores it.
*/
export const WRITE_NOW_PARAM = 'writeNow'

/** Whether the address asks for the page to be written on arrival. */
export function hasWriteNow(searchParams: URLSearchParams): boolean {
  return searchParams.has(WRITE_NOW_PARAM)
}

/** The same address with the marker taken off, and everything else it asks for left as it was. */
export function withoutWriteNow(searchParams: URLSearchParams): URLSearchParams {
  const rest = new URLSearchParams(searchParams)
  rest.delete(WRITE_NOW_PARAM)
  return rest
}

/** A page detail address, asking for the page to be written on arrival. */
export function withWriteNow(pageDetailUrl: string): string {
  return `${pageDetailUrl}${pageDetailUrl.includes('?') ? '&' : '?'}${WRITE_NOW_PARAM}=1`
}

export function buildPageDetailRecoveryUrl(domainSlug: string, pagePath: string) {
  const normalizedPath = pagePath.startsWith('/') ? pagePath : `/${pagePath}`
  const url = `https://${domainSlug}${normalizedPath}`
  const params = new URLSearchParams({
    url,
    source: 'page-detail',
  })

  return `/domains/${encodeURIComponent(domainSlug)}/monitor-setup?${params.toString()}`
}

export function getPageDetailNotReadyPayload(error: unknown) {
  const responseData = (error as any)?.response?.data
  if (responseData?.code !== 'PAGE_DETAIL_NOT_READY') return null

  return {
    message: typeof responseData.message === 'string' ? responseData.message : null,
    setupUrl: typeof responseData.data?.setupUrl === 'string' ? responseData.data.setupUrl : null,
    domainUrl: typeof responseData.data?.domainUrl === 'string' ? responseData.data.domainUrl : null,
  }
}

export function getPageDetailTemporarilyUnavailablePayload(error: unknown) {
  const responseData = (error as any)?.response?.data
  if (responseData?.code !== 'PAGE_DETAIL_LOOKUP_UNAVAILABLE') return null

  return {
    message: typeof responseData.error === 'string'
      ? responseData.error
      : 'Page details are temporarily unavailable. Please try again in a few moments.',
  }
}

export function shouldRetryUnifiedPageDetail(failureCount: number, error: unknown) {
  const status = (error as any)?.response?.status
  if (typeof status === 'number' && status >= 400 && status < 500) return false

  return failureCount < 2
}
